/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meetings_SubInputs */

const th_meetings_sub = /** @type {(inputs: Meetings_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การพูดคุยกับผู้ใช้คนอื่น ใครก็เชิญได้ และคุณเป็นคนตัดสินใจ`)
};

const en_meetings_sub = /** @type {(inputs: Meetings_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calls with other people on the platform. Anyone can ask; you decide.`)
};

const ja_meetings_sub = /** @type {(inputs: Meetings_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プラットフォーム上の人との通話です。誰でも誘えますが、決めるのはあなたです。`)
};

const zh_meetings_sub = /** @type {(inputs: Meetings_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`与平台上其他人的对话。谁都可以提出；由你来决定。`)
};

const es_meetings_sub = /** @type {(inputs: Meetings_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Llamadas con otras personas de la plataforma. Cualquiera puede proponerlas; tú decides.`)
};

const pt_meetings_sub = /** @type {(inputs: Meetings_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chamadas com outras pessoas da plataforma. Qualquer um pode propor; você decide.`)
};

const id_meetings_sub = /** @type {(inputs: Meetings_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Percakapan dengan orang lain di platform. Siapa pun boleh meminta; Anda yang memutuskan.`)
};

const fr_meetings_sub = /** @type {(inputs: Meetings_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Appels avec d’autres personnes de la plateforme. N’importe qui peut proposer ; c’est vous qui décidez.`)
};

const tl_meetings_sub = /** @type {(inputs: Meetings_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga usapan sa iba sa plataporma. Sinuman ay maaaring magtanong; ikaw ang magpapasya.`)
};

const vi_meetings_sub = /** @type {(inputs: Meetings_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trò chuyện với người khác trên nền tảng. Ai cũng có thể hỏi; bạn là người quyết định.`)
};

const ko_meetings_sub = /** @type {(inputs: Meetings_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`플랫폼의 다른 사람들과 나누는 대화. 누구나 요청할 수 있고, 결정은 회원님이 합니다.`)
};

const de_meetings_sub = /** @type {(inputs: Meetings_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gespräche mit anderen auf der Plattform. Fragen darf jeder; entscheiden tust du.`)
};

const ru_meetings_sub = /** @type {(inputs: Meetings_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Разговоры с другими на платформе. Попросить может любой; решаете вы.`)
};

const tr_meetings_sub = /** @type {(inputs: Meetings_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platformdaki diğer kişilerle görüşmeler. Herkes isteyebilir; karar sizin.`)
};

const it_meetings_sub = /** @type {(inputs: Meetings_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversazioni con altre persone sulla piattaforma. Chiunque può chiedere; decidi tu.`)
};

const pl_meetings_sub = /** @type {(inputs: Meetings_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rozmowy z innymi na platformie. Każdy może poprosić; decydujesz ty.`)
};

const uk_meetings_sub = /** @type {(inputs: Meetings_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Розмови з іншими на платформі. Попросити може будь-хто; вирішуєте ви.`)
};

const hi_meetings_sub = /** @type {(inputs: Meetings_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्लेटफ़ॉर्म पर दूसरों से बातचीत। कोई भी पूछ सकता है; निर्णय आपका है।`)
};

const ar_meetings_sub = /** @type {(inputs: Meetings_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`محادثات مع غيرك على المنصّة. لأي أحد أن يطلب؛ والقرار لك.`)
};

const ms_meetings_sub = /** @type {(inputs: Meetings_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perbualan dengan orang lain di platform. Sesiapa boleh meminta; anda yang menentukan.`)
};

const bn_meetings_sub = /** @type {(inputs: Meetings_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`প্ল্যাটফর্মের অন্যদের সঙ্গে কথোপকথন। যে কেউ চাইতে পারেন; সিদ্ধান্ত আপনার।`)
};

const zh_tw2_meetings_sub = /** @type {(inputs: Meetings_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`與平台上其他人的對話。任何人都可以提出；由你決定。`)
};

const zh_hk2_meetings_sub = /** @type {(inputs: Meetings_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`與平台上其他人的對話。任何人都可以提出；由你決定。`)
};

const ur_meetings_sub = /** @type {(inputs: Meetings_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`پلیٹ فارم پر دوسروں سے گفتگو۔ کوئی بھی کہہ سکتا ہے؛ فیصلہ آپ کا ہے۔`)
};

const fa_meetings_sub = /** @type {(inputs: Meetings_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`گفت‌وگو با دیگران در پلتفرم. هر کسی می‌تواند بخواهد؛ تصمیم با شماست.`)
};

const sw_meetings_sub = /** @type {(inputs: Meetings_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mazungumzo na wengine kwenye jukwaa. Yeyote anaweza kuomba; wewe ndiye unaamua.`)
};

const nl_meetings_sub = /** @type {(inputs: Meetings_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesprekken met anderen op het platform. Iedereen mag het vragen; jij beslist.`)
};

/**
* | output |
* | --- |
* | "Calls with other people on the platform. Anyone can ask; you decide." |
*
* @param {Meetings_SubInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const meetings_sub = /** @type {((inputs?: Meetings_SubInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meetings_SubInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_meetings_sub(inputs)
	if (locale === "ja") return ja_meetings_sub(inputs)
	if (locale === "zh") return zh_meetings_sub(inputs)
	if (locale === "es") return es_meetings_sub(inputs)
	if (locale === "pt") return pt_meetings_sub(inputs)
	if (locale === "id") return id_meetings_sub(inputs)
	if (locale === "fr") return fr_meetings_sub(inputs)
	if (locale === "tl") return tl_meetings_sub(inputs)
	if (locale === "vi") return vi_meetings_sub(inputs)
	if (locale === "ko") return ko_meetings_sub(inputs)
	if (locale === "de") return de_meetings_sub(inputs)
	if (locale === "ru") return ru_meetings_sub(inputs)
	if (locale === "tr") return tr_meetings_sub(inputs)
	if (locale === "it") return it_meetings_sub(inputs)
	if (locale === "pl") return pl_meetings_sub(inputs)
	if (locale === "uk") return uk_meetings_sub(inputs)
	if (locale === "hi") return hi_meetings_sub(inputs)
	if (locale === "ar") return ar_meetings_sub(inputs)
	if (locale === "ms") return ms_meetings_sub(inputs)
	if (locale === "bn") return bn_meetings_sub(inputs)
	if (locale === "zh-TW") return zh_tw2_meetings_sub(inputs)
	if (locale === "zh-HK") return zh_hk2_meetings_sub(inputs)
	if (locale === "ur") return ur_meetings_sub(inputs)
	if (locale === "fa") return fa_meetings_sub(inputs)
	if (locale === "sw") return sw_meetings_sub(inputs)
	if (locale === "nl") return nl_meetings_sub(inputs)
	return en_meetings_sub(inputs)
});